export const getChartColors = (index: number) => {
  // Use base colors directly for first 5 (indices 0-4), then fall back to opacity for additional entries
  const colorIndex = index % 5;

  if (index < 5) {
    return `var(--data-${colorIndex + 1})`;
  }

  if (index < 10) {
    return `color-mix(in srgb, var(--data-${colorIndex + 1}) 60%, white)`;
  }

  return `color-mix(in srgb, var(--data-${colorIndex + 1}) 20%, white)`;
};

export const getBrowserChartColors = (index: number) => {
  const opacities = [0.9, 0.7, 0.5, 0.3, 0.1];
  const opacity = opacities[index % opacities.length];

  return `color-mix(in srgb, var(--data-1) ${opacity * 100}%, white)`;
};

export const getInvestorTypeChartColor = (
  chartIndex: number,
  opacity?: number,
) => {
  const baseColor = `var(--chart-${chartIndex})`;

  if (opacity !== undefined) {
    // Ensure 0 <= opacity <= 100
    const ratio = Math.max(0, Math.min(100, opacity));

    return `color-mix(in srgb, hsl(${baseColor}) ${ratio}%, transparent)`;
  }

  return `hsl(var(--chart-${chartIndex}))`;
};
